

























































































































import { CognitoIdentityServiceProvider } from 'aws-sdk'
import { Component, Vue } from 'vue-property-decorator'
import * as PolicyHelper from '../util/PasswordPolicy'
import fetch from 'node-fetch'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

@Component
export default class ResetPassword extends Vue {
    // existing user
    private email = ''
    private verificationCode = this.$route.query.code

    // pending password reset
    private passwordReset = ''
    private passwordResetConfirm = ''
    private passwordRequirements = ''
    private passwordPolicy: CognitoIdentityServiceProvider.PasswordPolicyType = {}
    private passwordErrors: string[] = []

    private protocol: string = Vue.prototype.$secureCookies ? 'https' : 'http'
    private protocolApi: string = Vue.prototype.$secureApi ? 'https' : 'http'

    // methods
    public async resetPassword (): Promise<void> {
      this.passwordErrors = []
      try {
        PolicyHelper.ConformToPolicy(this.passwordPolicy, this.passwordReset, this.passwordResetConfirm)
        await fetch(`${this.protocolApi}://${Vue.prototype.$hostApi}/api/confirm-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: this.email,
            verificationCode: this.verificationCode,
            newPassword: this.passwordReset
          })
        })
        this.$router.push('/')
      } catch (err) {
        if (err instanceof PolicyHelper.PasswordResetError) {
          this.passwordErrors.push(err.toString())
        }
      }
    }

    public async created (): Promise<void> {
      const policy = await PolicyHelper.GetPasswordPolicy(`${this.protocolApi}://${Vue.prototype.$hostApi}`)
      this.passwordRequirements = PolicyHelper.BuildPolicySentence(policy)
      this.passwordPolicy = policy
    }
}
